// extracted by mini-css-extract-plugin
export default {"container":"UserProfile_container__atTev"};